import { apiCall, API_CONFIG } from './api';

export const userAPI = {
  // Get total user statistics
  getTotalUserStats: async () => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.USER_STATS, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch user stats:', error);
      throw error;
    }
  },

  // Get user details with order summary by email or phone
  getUserDetails: async (searchType, searchValue) => {
    try {
      const params = new URLSearchParams();

      if (searchType === 'email') {
        params.append('email', searchValue);
      } else if (searchType === 'phone') {
        params.append('phoneNumber', searchValue);
      } else if (searchType === 'id') {
        params.append('userId', searchValue);
      }

      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.USER_DETAILS}?${params.toString()}`,
        { method: 'GET' }
      );
      return response;
    } catch (error) {
      console.error('Failed to fetch user details:', error);
      throw error;
    }
  },

  // Generate otp
  generateAddressEditOtp: async (userId, addressId) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.GENERATE_ADDRESS_EDIT_OTP, {
        method: 'POST',
        body: JSON.stringify({ userId, addressId }),
      });
      return response;
    } catch (error) {
      console.error('Failed to generate OTP:', error);
      throw error;
    }
  },

  // Verify OTP for address edit
  verifyAddressEditOtp: async (requestId, otp) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.VERIFY_ADDRESS_EDIT_OTP, {
        method: 'POST',
        body: JSON.stringify({ requestId, otp }),
      });
      return response;
    } catch (error) {
      console.error('Failed to verify OTP:', error);
      throw error;
    }
  },

  // Update user address
  updateUserAddress: async (requestId, addressId, userId, addressData) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.UPDATE_USER_ADDRESS, {
        method: 'PUT',
        body: JSON.stringify({ requestId, addressId, userId, ...addressData }),
      });
      return response;
    } catch (error) {
      console.error('Failed to update address:', error);
      throw error;
    }
  },

  // Get user action logs by userId
  getUserActionLogs: async (userId, page = 1, limit) => {
    try {
      const queryParams = new URLSearchParams();
      if (page) queryParams.append('page', page);
      if (limit) queryParams.append('limit', limit);

      const endpoint = `${API_CONFIG.ENDPOINTS.USER_ACTION_LOGS}/${userId}?${queryParams.toString()}`;
      const response = await apiCall(endpoint, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch user action logs:', error);
      throw error;
    }
  },

  // Get user coin history by userId
  getUserCoinHistory: async (userId, page = 1, limit = 20, filter = 'all') => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page);
      queryParams.append('limit', limit);
      queryParams.append('filter', filter);

      const endpoint = `${API_CONFIG.ENDPOINTS.USER_COIN_HISTORY}/${userId}?${queryParams.toString()}`;
      const response = await apiCall(endpoint, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch user coin history:', error);
      throw error;
    }
  },

  // Get user wallet history by userId
  getUserWalletHistory: async (userId, page = 1, limit = 20, filter = 'all') => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page);
      queryParams.append('limit', limit);
      queryParams.append('filter', filter);

      const endpoint = `${API_CONFIG.ENDPOINTS.USER_WALLET_HISTORY}/${userId}?${queryParams.toString()}`;
      const response = await apiCall(endpoint, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch user wallet history:', error);
      throw error;
    }
  },

  // Get user coupons by userId
  getUserCoupons: async (userId, filter = 'active') => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('filter', filter);

      const endpoint = `${API_CONFIG.ENDPOINTS.USER_COUPONS}/${userId}?${queryParams.toString()}`;
      const response = await apiCall(endpoint, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch user coupons:', error);
      throw error;
    }
  },
};
